import React from "react";
import { Frame, Lead } from "./styles";

export interface Props {
	type: "Q" | "A" | "speaker" | "host" | "continued" | "lead";
	name?: string;
	text: string;
}
const ArticleNode: React.FC<Props> = (props) => {
	const { type, text, name } = props;
	return (
		<>
			{type == "lead" ? (
				<Lead>{text}</Lead>
			) : (
				<Frame type={type}>
					<dt>
						{!type || type == "Q"
							? "Q"
							: type == "A"
							? "A"
							: type == "speaker"
							? `${name}：`
							: type == "host"
							? "筆者"
							: type == "continued" && "引続"}
					</dt>
					<dd>{text}</dd>
				</Frame>
			)}
		</>
	);
};

export default ArticleNode;
